import { FOCO_VISIVEL } from 'utils/foco';

/** O que as ações precisam do modelo do `TaskItem`/`TaskItemMad`. */
export interface ModeloDaParticipacao {
  data: any;
  canDecreaseParticipation: (membro: any) => boolean;
  canExcludeParticipation: (membro: any) => boolean;
  setUserToChange: (chave: string) => void;
  showModal: (modal: string) => void;
}

const ACAO_DE_TEXTO = `cursor-pointer border-0 bg-transparent p-0 text-[11px] font-bold uppercase tracking-[0.04em] hover:underline ${FOCO_VISIVEL}`;

/**
 * Reduzir e Excluir na linha de um participante do "Ver mais", como o `TaskItem` faz: aparecem com
 * `canDecreaseParticipation`/`canExcludeParticipation` (o próprio participante ou o gestor dele) e abrem os mesmos
 * modais `team-member-decrease`/`team-member-exclude` com o participante em `userToChange`.
 */
export default function AcoesDoParticipante({ pessoa, modelo }: { pessoa: any; modelo: ModeloDaParticipacao }) {
  const podeReduzir = modelo.canDecreaseParticipation(pessoa);
  const podeExcluir = modelo.canExcludeParticipation(pessoa);

  if (!podeReduzir && !podeExcluir) return null;

  const nome = pessoa.extra?.nome_guerra?.split(' ')[0] || pessoa._id;

  function abrir(modal: 'team-member-decrease' | 'team-member-exclude') {
    modelo.setUserToChange(pessoa._id);
    modelo.showModal(`${modal}-${modelo.data._id}`);
  }

  return (
    <div className="flex basis-full flex-wrap justify-end gap-3.5">
      {podeReduzir && (
        <button
          type="button"
          aria-label={`Reduzir percentual de atuação de ${nome}`}
          onClick={() => abrir('team-member-decrease')}
          className={`${ACAO_DE_TEXTO} text-brand-blue`}
        >
          Reduzir percentual
        </button>
      )}
      {podeExcluir && (
        <button
          type="button"
          aria-label={`Excluir participação de ${nome}`}
          onClick={() => abrir('team-member-exclude')}
          className={`${ACAO_DE_TEXTO} text-urgent`}
        >
          Excluir participação
        </button>
      )}
    </div>
  );
}
